import { useQuery } from '@tanstack/react-query';
import { useWarnIfProviderMissing } from './useWarnIfProviderMissing';
import {
	accountTradingDataQueryKeys,
	GC_TIME_MS,
} from './accountTradingDataQueryKeys';
import {
	LeftoverIsolatedPositionsResult,
	LeftoverIsolatedByUserKey,
} from './utils/types';

export function useLeftoverIsolatedByUserKey(userKey: string | undefined) {
	useWarnIfProviderMissing('useLeftoverIsolatedByUserKey');

	return useQuery<
		LeftoverIsolatedByUserKey,
		unknown,
		LeftoverIsolatedPositionsResult | undefined
	>({
		queryKey: accountTradingDataQueryKeys.leftoverIsolatedPositions(),
		queryFn: () => ({}),
		enabled: false,
		staleTime: Infinity,
		gcTime: GC_TIME_MS,
		select: (data) => (userKey ? data?.[userKey] : undefined),
	});
}
